import { render } from "./OnboardingWizard.vue?vue&type=template&id=4b97e52a"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__